import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import {BaseListResponse, BaseModel, WarningBaseModel} from '../models/BaseModel';
import { ApplicationFileInfo, GrantApplicationResponse } from '../models/grantApplication/grantApplicationResponse';
import {GrantApplicationTaskResponse} from "../models/grantApplication/grantapplicationtaskResponse";
import {GrantApplicationSubmittedReportResponse} from "../models/grantApplication/grantApplicationSubmittedReportResponse";
import {GrantApplicationReportDueResponse} from "../models/grantApplication/grantApplicationReportDueResponse";
import {baseFile, GrantApplicationGetInforResponse} from "../models/grantApplication/grantApplicationGetinfoResponse";
import {
  GeneratePSASigningLinkRequest,
  GeneratePSASigningLinkResponse
} from "../models/grantApplication/generatePSASigningLinkRequest";
import {VerifiedSignedStatusResponse} from "../models/assignment/GenerateFWASigningLinkRequest";
import { lorem } from "../utils/lorem";

@Injectable({
  providedIn: 'root'
})
export class GrantApplicationService {
  private apiUrl = environment.apiConfig.uri+ '/api/grantapplication';

  constructor(private http: HttpClient) { }



  getApplicationList(page : number, limit: number, sortColumn : string): Observable<BaseModel<BaseListResponse<GrantApplicationResponse>>> {
    return this.http.get<BaseModel<BaseListResponse<GrantApplicationResponse>>>(`${this.apiUrl}/query/${page}/${limit}?sort=${sortColumn}`);
  }

  create(formData: any): Observable<WarningBaseModel<any>> {
    return this.http.post<WarningBaseModel<GrantApplicationResponse>>(`${this.apiUrl}/submit`, formData);
  }
  createEmergency(formData: any): Observable<WarningBaseModel<any>> {
    return this.http.post<WarningBaseModel<string>>(`${this.apiUrl}/submitemergency`, formData);
  }

  downloadFile(fileId: string): Observable<BaseModel<ApplicationFileInfo>> {
    return this.http.get<BaseModel<ApplicationFileInfo>>(`${this.apiUrl}/download/${fileId}`);
  }

  getTasks(appId: string):Observable<BaseModel<GrantApplicationTaskResponse[]>> {
    return this.http.get<BaseModel<GrantApplicationTaskResponse[]>>(`${this.apiUrl}/gettasks/${appId}`);
  }


  getReportDue(appId: string):Observable<BaseModel<GrantApplicationReportDueResponse[]>> {
    return this.http.get<BaseModel<GrantApplicationReportDueResponse[]>>(`${this.apiUrl}/getreportsdue/${appId}`);
  }

  getReportType(appId: string):Observable<BaseModel<GrantApplicationSubmittedReportResponse[]>> {
    return this.http.get<BaseModel<GrantApplicationSubmittedReportResponse[]>>(`${this.apiUrl}/getreportssubmitted/${appId}`);
  }

  getRegardingReport(referenceId: string):Observable<WarningBaseModel<string>> {
    return this.http.get<WarningBaseModel<string>>(`${this.apiUrl}/regardingreport/${referenceId}`);
  }

  getInfo(applicationId: string):Observable<BaseModel<GrantApplicationGetInforResponse>> {
    return this.http.get<BaseModel<GrantApplicationGetInforResponse>>(`${this.apiUrl}/getinfo/${applicationId}`);
  }

  getDocs(applicationId: string):Observable<BaseModel<baseFile[]>> {
    return this.http.get<BaseModel<baseFile[]>>(`${this.apiUrl}/getdocuments/${applicationId}`);
  }

  signTerm(applicationId: string): Observable<WarningBaseModel<any>> {
    return this.http.post<any>(`${this.apiUrl}/signterm/${applicationId}`, {});
  }

  signCoC(applicationId: string): Observable<WarningBaseModel<any>> {
    return this.http.post<any>(`${this.apiUrl}/signcoc/${applicationId}`, {});
  }

  upLoadDocument(formData: any): Observable<BaseModel<any>> {
    return this.http.post<BaseModel<GrantApplicationResponse>>(`${this.apiUrl}/update`, formData);
  }


  SaveDraft(formData: any): Observable<WarningBaseModel<any>> {
    return this.http.post<WarningBaseModel<GrantApplicationResponse>>(`${this.apiUrl}/savedraft`, formData);
  }


  saveDraftEmergency(formData: any): Observable<WarningBaseModel<any>> {
    return this.http.post<WarningBaseModel<GrantApplicationResponse>>(`${this.apiUrl}/savedraftemergency`, formData);
  }

  GeneratePSALink(generatePSALinkRequest: GeneratePSASigningLinkRequest): Observable<BaseModel<GeneratePSASigningLinkResponse>> {
    return this.http.post<BaseModel<GeneratePSASigningLinkResponse>>(`${this.apiUrl}/generatepsalink`, generatePSALinkRequest);
  }


  getDocsStatus(contractsignaturedetailId: string|undefined):Observable<BaseModel<VerifiedSignedStatusResponse>> {
    return this.http.get<BaseModel<VerifiedSignedStatusResponse>>(`${this.apiUrl}/getpsasigningstatus/${contractsignaturedetailId}`);
  }

  getSignedDocuments(applicationId: string):Observable<BaseModel<baseFile>> {
    return this.http.get<BaseModel<baseFile>>(`${this.apiUrl}/getsigneddocuments/${applicationId}`);
  }

  downloadPSAFile(fileId: string): Observable<BaseModel<ApplicationFileInfo>> {
    return this.http.get<BaseModel<ApplicationFileInfo>>(`${this.apiUrl}/download/${fileId}`);
  }

  // Mock version of getApplicationList: returns static data with simple pagination and optional sorting
  getApplicationListMock(page: number, limit: number, sortColumn: string): Observable<BaseModel<BaseListResponse<GrantApplicationResponse>>> {
    const mockItems: GrantApplicationResponse[] = [
      {
        grantApplicationId: 'GA-0001',
        name: 'Maternal Health Support',
        applicantName: 'Hope Foundation',
        description: "healtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealtyhealty\n\nhealty healty",
        currencyCode: 'USD',
        projectName: 'Maternal Health Initiative',
        budget: 120000,
        status: 'Submitted',
        projectId: 'P-3001',
        applicantOrganisationName: 'Hope Foundation Org',
        proposalDetail: 'Provide training and equipment to clinics.',
        grantApplicationType: 'Standard',
      },
      {
        grantApplicationId: 'GA-0002',
        name: 'Clean Water Project',
        applicantName: 'WaterWorks',
        description: lorem(1000),
        currencyCode: 'EUR',
        projectName: 'Rural Water Access',
        budget: 85000,
        status: 'Approved',
        projectId: 'P-3002',
        applicantOrganisationName: 'WaterWorks Intl',
        proposalDetail: 'Target 10 villages across the region.',
        grantApplicationType: 'Standard',
       },
      {
        grantApplicationId: 'GA-0003',
        name: 'Emergency Food Aid',
        applicantName: 'ReliefNow',
        description: lorem(1000),
        currencyCode: 'USD',
        projectName: 'Rapid Response Program',
        budget: 50000,
        status: 'Finalized',
        projectId: 'P-3003',
        applicantOrganisationName: 'ReliefNow Org',
        proposalDetail: 'Immediate aid for 5,000 people.',
        grantApplicationType: 'Emergency',
      },
      {
        grantApplicationId: 'GA-0004',
        name: 'Youth Education Support',
        applicantName: 'Learn4Life',
        description: lorem(1000),
        currencyCode: 'GBP',
        projectName: 'Education Access',
        budget: 60000,
        status: 'On Hold',
        projectId: 'P-3004',
        applicantOrganisationName: 'Learn4Life Org',
        proposalDetail: 'Scholarships and school supplies.',
        grantApplicationType: 'Standard',
      },
      {
        grantApplicationId: 'GA-0005',
        name: 'Clinic Upgrade',
        applicantName: 'HealthFirst',
        description: lorem(1000),
        currencyCode: 'USD',
        projectName: 'Facility Upgrade Project',
        budget: 150000,
        status: 'Submitted',
        projectId: 'P-3005',
        applicantOrganisationName: 'HealthFirst Org',
        proposalDetail: 'New diagnostic equipment and training.',
        grantApplicationType: 'Standard',
      },
      {
        grantApplicationId: 'GA-0006',
        name: 'Nutrition Program',
        applicantName: 'NutriCare',
        description: 'Community nutrition education and support.',
        currencyCode: 'USD',
        projectName: 'Nutrition Program Evaluation',
        budget: 40000,
        status: 'Not Submitted',
        projectId: 'P-3006',
        applicantOrganisationName: 'NutriCare Org',
        proposalDetail: 'Workshops and supplemental feeding.',
        grantApplicationType: 'Standard',
      },
      {
        grantApplicationId: 'GA-0007',
        name: 'Mobile Health Clinics',
        applicantName: 'MedReach',
        description: 'Deploy mobile clinics in remote areas.',
        currencyCode: 'USD',
        projectName: 'Rural Clinic Outreach',
        budget: 95000,
        status: 'Approved',
        projectId: 'P-3007',
        applicantOrganisationName: 'MedReach Org',
        proposalDetail: 'Mobile units covering 12 communities.',
        grantApplicationType: 'Standard',
      },
      {
        grantApplicationId: 'GA-0008',
        name: 'Disease Surveillance',
        applicantName: 'HealthWatch',
        description: 'Improve disease surveillance systems.',
        currencyCode: 'USD',
        projectName: 'Disease Surveillance Mapping',
        budget: 70000,
        status: 'Submitted',
        projectId: 'P-3008',
        applicantOrganisationName: 'HealthWatch Org',
        proposalDetail: 'GIS mapping and reporting tools.',
        grantApplicationType: 'Standard',
      },
      {
        grantApplicationId: 'GA-0009',
        name: 'Community Engagement',
        applicantName: 'CommunityHub',
        description: 'Community meetings and awareness campaigns.',
        currencyCode: 'USD',
        projectName: 'Health Promotion Campaign',
        budget: 30000,
        status: 'Finalized',
        projectId: 'P-3009',
        applicantOrganisationName: 'CommunityHub Org',
        proposalDetail: 'Monthly meetings and materials.',
        grantApplicationType: 'Standard',
      },
      {
        grantApplicationId: 'GA-0010',
        name: 'Budget Optimization',
        applicantName: 'FinTrack',
        description: 'Improve budget tracking and utilization.',
        currencyCode: 'USD',
        projectName: 'Budget Management',
        budget: 20000,
        status: 'On Hold',
        projectId: 'P-3010',
        applicantOrganisationName: 'FinTrack Org',
        proposalDetail: 'Deploy budget tracking tools and training.',
        grantApplicationType: 'Standard',
      }
    ];

    // Sorting support by a few known columns; default to ProjectName
    const sortKey = (sortColumn || 'ProjectName').toLowerCase();
    const itemsSorted = [...mockItems].sort((a, b) => {
      const getVal = (x: GrantApplicationResponse): any => {
        switch (sortKey) {
          case 'projectname': return x.projectName?.toString().toLowerCase();
          case 'name': return x.name?.toString().toLowerCase();
          case 'budget': return x.budget ?? 0;
          case 'status': return x.status?.toString().toLowerCase();
          default: return x.projectName?.toString().toLowerCase();
        }
      };
      const av = getVal(a);
      const bv = getVal(b);
      if (av < bv) return -1;
      if (av > bv) return 1;
      return 0;
    });

    const total = itemsSorted.length;
    const currentPage = Math.max(1, Math.floor(page || 1));
    const pageSize = Math.max(1, Math.floor(limit || 10));
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;
    const paged = itemsSorted.slice(start, end);

    const response: BaseModel<BaseListResponse<GrantApplicationResponse>> = {
      result: true,
      item: {
        isClientSide: true,
        total: total,
        displayTotal: paged.length,
        items: paged,
        summary: null
      }
    };

    return of(response);
  }

}
